import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class AssociarUserTerceiroGrupoService {

  constructor(private http:HttpClient, private httpService:HttpService) { }

  searchGrupos(data:any) {
    return this.http.get(API + '/accessProfile',{params:data});
  }

  searchGrupoById(data:any) {
    return this.http.get(API + '/accessProfile/'+data);
  }
  
  searchUsers(data:any){
    return this.http.get(API + '/accessProfile/outsourcedAccess',{params:data});
  }

  searchUsersGroup(data:any){
    return this.http.get(API + '/accessProfile/outsourcedAccessProfile',{params:data});
  }

  saveUsersGroup(data:any, successHandle:Function, errorHandle:Function){
    return this.httpService.doPost('/accessUserProfile',data, successHandle, errorHandle);
  }
}
